import React from 'react'
import AppFeatures from './app-features'
import AppStoreBadges from './AppStoreBadges'
import Heading from './heading'
import Text from './text'

export default function Popup({setIsHidden}: {setIsHidden: ()=>void}) {
  React.useEffect(() => window.scrollTo({top: 0}), [])
    return <div>
      <div style={{
        position: 'fixed', 
        top: 0, 
        left: 0, 
        bottom: 0, 
        right: 0, 
        backgroundColor: 'rgba(0,0,0,0.6)',
        zIndex: 8990,
      }} />
  
      <div style={{
        padding: '30px 60px',
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 9000,
        backgroundColor: '#FFB600',
        borderRadius: 8,
        borderTopRightRadius: 0,
        boxShadow: '0px 15px 45px -23px rgba(0,0,0,0.58)',
        overflow: 'visible'
      }}>
        <Heading light center small mb>Download the mobile app</Heading>
        <div style={{maxWidth: 422, marginBottom: 24,}}>
          <AppFeatures light />
        </div>
        
        <AppStoreBadges />
  
        <div style={{position: 'absolute', top: 0, right: -8,}}>
          <button
            style={{
              backgroundColor: 'transparent', 
              cursor: 'pointer',
              border: 'none', 
              color: 'white', 
              fontSize: 44, 
              padding: '12px 40px',
            }}
            onClick={() => setIsHidden(true)}
          >&times;</button>
        </div>
  
      </div>
    </div>
  }